<template>
  <div 
    :class="$style.wrapper"
    :style="`height: ${height}px`"
    >
    <div
      ref="content"
      :class="$style.content"
      :style="{transform: `scale(${scale})`}"
    >
      <slot ref="slot" />
    </div>
  </div>
</template>
<script>


export default {

  name: 'Scale',
  
  data: () => ({
    scale: 1,
    height: 'auto',
    offsetWidth: 0,
    offsetHeight: 0, 
    observer: null,
  }),

  mounted() {

    this.observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        this.calculate()
      }
    });

    this.observer.observe(this.$refs.content);

    this.calculate();

  },

  beforeDestroy() {
    this.observer.disconnect()
  },

  methods: {

    calculate() {

      const contentWidth = this.$refs.content.children[0] ? this.$refs.content.children[0].offsetWidth : 0
      const contentHeight = this.$refs.content.children[0] ? this.$refs.content.children[0].offsetHeight : 0

      this.width = this.$el.offsetWidth
      this.scale = this.width / contentWidth
      this.height = contentHeight * this.scale

    }
  }
}

</script>


<style module>

.wrapper {
  width: 100%;
	position: relative;
}

.content {
  transform-origin: left top;
}

</style>